export type RequestErrorHandler = {
    (error: Error): any;
};
export const dummyErrorHandling: RequestErrorHandler = (error) => {
    console.error(error);
};
